import React, { useState, useEffect } from "react";
import { clsx } from "clsx";
import { useTranslation } from "react-i18next";

const TransactionStatusChecker: React.FC = () => {
  const [phraseIndex, setPhraseIndex] = useState<number>(-1);
  const { t } = useTranslation();
  const PHRASES = [
    t("transactionStatus.searchingBlockchain"),
    t("transactionStatus.tracking"),
  ] as const;

  const currentPhrase = phraseIndex === -1 ? "" : PHRASES[phraseIndex];

  useEffect(() => {
    let intervalId: NodeJS.Timeout | undefined;

    const initialTimer: NodeJS.Timeout = setTimeout(() => {
      setPhraseIndex(0);

      intervalId = setInterval(() => {
        setPhraseIndex((prevIndex) => {
          return (prevIndex + 1) % PHRASES.length;
        });
      }, 3000);

      return () => {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };
    }, 1000);

    return () => {
      clearTimeout(initialTimer);
    };
  }, []);

  if (!currentPhrase) {
    return null;
  }

  const isPulsing = true;

  return (
    <div className="flex items-center justify-center py-2 bg-[#1a1a1a] rounded-[12px] max-lg:rounded-[12px] border border-[#333333]">
      <div
        className="w-[22px] h-[22px] max-lg:w-[19px] max-lg:h-[19px]
                   border-[3px] max-lg:border-[3px] border-[#333333] border-t-white rounded-full
                   animate-spin mr-[14px] max-lg:mr-[11px]"
      ></div>

      <span
        className={clsx(
          "text-white text-[14px] max-lg:text-14m font-luxora-medium transition-opacity duration-500",
          {
            "animate-pulse": isPulsing,
          }
        )}
      >
        {currentPhrase}
      </span>
    </div>
  );
};

export default TransactionStatusChecker;
